import React, { useState, useEffect } from "react";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaTripadvisor } from "react-icons/fa";
import { FaBowlRice } from "react-icons/fa6";
import { BsTwitterX } from "react-icons/bs";
import { IoLogoWhatsapp } from "react-icons/io";

import instance from "../../services/ApiServices";
import { Link } from "react-router-dom";

function SocialMedia() {
  const endpoint = "social";
  const [socials, setSocials] = useState([]);

  function renderSwitch(params) {
    switch (params) {
      case "twitter":
        return <BsTwitterX />;
      case "facebook":
        return <FaFacebook />;
      case "googlemap":
        return <FaMapMarkerAlt />;
      case "instagram":
        return <FaInstagram />;
      case "tripadvisor":
        return <FaTripadvisor />;
      case "whatsapp":
        return <IoLogoWhatsapp />;
      case "openrice":
        return <FaBowlRice />;
      default:
        return <FaMapMarkerAlt />;
    }
  }

  useEffect(() => {
    instance.get(endpoint).then((res) => {
      setSocials(res.data);
    });
  }, []);

  // console.log(JSON.stringify(socials))
  return (
    <div className="flex flex-row gap-3 text-2xl py-5">
      {socials.map((social, index) => (
        <Link
          key={index}
          href={social.link}
          target="_blank"
        >
          {renderSwitch(social.name)}
        </Link>
      ))}
    </div>
  );
}

export default SocialMedia;
